import { serviceName } from '../resources/serviceConstants';
import {
  CERTIFICATIONS_LIST,
  ENABLE_DISABLE_CERTIFICATION,
  ADD_EDIT_CERTIFICATION,
  ADD_EDIT_TARGETS,
  GET_TARGETS,
  CERTIFICATION_VERTICAL_COUNT,
} from '../resources/endPoint';

export const certificationList = () => {
  // API call to fetch certification list
  return {
    url: CERTIFICATIONS_LIST,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const enableOrDisableCertification = (data) => {
  // API call to enable/disable certification

  return {
    url: ENABLE_DISABLE_CERTIFICATION,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const addCertificationData = (
  providerID,
  certificationName,
  certificationprovider,
  validityYear,
  categoryId,
  subCategoryId,
  lastUpdatedBy,
) => {
  const data = {
    provider_id: providerID,
    certification_name: certificationName,
    provider_name: certificationprovider,
    certification_validity: validityYear,
    category_id: categoryId,
    sub_category_id: subCategoryId,
    last_updated_by: lastUpdatedBy,
  };

  return {
    url: ADD_EDIT_CERTIFICATION,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const editCertificationData = ({
  certificationID,
  providerID,
  certificationName,
  certificationProvider,
  validityYear,
  categoryId,
  subCategoryId,
  lastUpdatedBy,
}) => {
  const data = {
    certification_id: certificationID,
    provider_id: providerID,
    certification_name: certificationName,
    provider_name: certificationProvider,
    certification_validity: validityYear,
    category_id: categoryId,
    sub_category_id: subCategoryId,
    last_updated_by: lastUpdatedBy,
  };

  return {
    url: ADD_EDIT_CERTIFICATION,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const addTargetData = (
  vertical_id,
  certification_id,
  certification_target,
  financial_year,
  quarter,
) => {
  const data = {
    verticalId: vertical_id,
    certificationId: certification_id,
    certificationTarget: certification_target,
    financialYear: financial_year,
    quarter: quarter,
  };

  return {
    url: ADD_EDIT_TARGETS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const getTargets = (year) => {
  const url = GET_TARGETS.replace('{year}', year);
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const certificationsVerticalCount = () => {
  return {
    url: CERTIFICATION_VERTICAL_COUNT,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const getTargetsDataUsingFlag = (year) => {
  const url = `${GET_TARGETS.replace(
    '{year}',
    year,
  )}?typeFlag=certificationOverview`;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
};
